import { http } from './config'

export default {
  getUnread: (localityId) => {
    return http.get('notifications/unread/?locality_id=' + localityId)
  },

  getNotifications: () => {
    return http.get('notifications')
  },

  getNotificationsByLocality: (params) => {
    return http.get('notifications/by_locality/', { params })
  },

  markAllRead: (localityId) => {
    return http.post('notifications/mark_all_read', {
      locality_id: localityId,
    })
  },

  markAsRead: (notificationId) => {
    return http.post('notifications/' + notificationId + '/mark_as_read')
  },

  last10Read: (localityId) => {
    return http.get('notifications/last_10_read', {
      locality_id: localityId,
    })
  },
}
